'use strict';

// AUTO-GENERATED — DO NOT EDIT
/** Autogenerated - FiatCurrency */ exports.FiatCurrency = void 0;
(function(FiatCurrency) {
    FiatCurrency["AED"] = "AED";
    FiatCurrency["AFN"] = "AFN";
    FiatCurrency["ALL"] = "ALL";
    FiatCurrency["AMD"] = "AMD";
    FiatCurrency["ANG"] = "ANG";
    FiatCurrency["AOA"] = "AOA";
    FiatCurrency["ARS"] = "ARS";
    FiatCurrency["AUD"] = "AUD";
    FiatCurrency["AWG"] = "AWG";
    FiatCurrency["AZN"] = "AZN";
    FiatCurrency["BAM"] = "BAM";
    FiatCurrency["BBD"] = "BBD";
    FiatCurrency["BDT"] = "BDT";
    FiatCurrency["BGN"] = "BGN";
    FiatCurrency["BHD"] = "BHD";
    FiatCurrency["BIF"] = "BIF";
    FiatCurrency["BMD"] = "BMD";
    FiatCurrency["BND"] = "BND";
    FiatCurrency["BOB"] = "BOB";
    FiatCurrency["BOV"] = "BOV";
    FiatCurrency["BRL"] = "BRL";
    FiatCurrency["BSD"] = "BSD";
    FiatCurrency["BTN"] = "BTN";
    FiatCurrency["BWP"] = "BWP";
    FiatCurrency["BYN"] = "BYN";
    FiatCurrency["BYR"] = "BYR";
    FiatCurrency["BZD"] = "BZD";
    FiatCurrency["CAD"] = "CAD";
    FiatCurrency["CDF"] = "CDF";
    FiatCurrency["CHE"] = "CHE";
    FiatCurrency["CHF"] = "CHF";
    FiatCurrency["CHW"] = "CHW";
    FiatCurrency["CLF"] = "CLF";
    FiatCurrency["CLP"] = "CLP";
    FiatCurrency["CNH"] = "CNH";
    FiatCurrency["CNY"] = "CNY";
    FiatCurrency["COP"] = "COP";
    FiatCurrency["COU"] = "COU";
    FiatCurrency["CRC"] = "CRC";
    FiatCurrency["CUC"] = "CUC";
    FiatCurrency["CUP"] = "CUP";
    FiatCurrency["CVE"] = "CVE";
    FiatCurrency["CZK"] = "CZK";
    FiatCurrency["DJF"] = "DJF";
    FiatCurrency["DKK"] = "DKK";
    FiatCurrency["DOP"] = "DOP";
    FiatCurrency["DZD"] = "DZD";
    FiatCurrency["EGP"] = "EGP";
    FiatCurrency["ERN"] = "ERN";
    FiatCurrency["ETB"] = "ETB";
    FiatCurrency["EUR"] = "EUR";
    FiatCurrency["FIUSD"] = "FIUSD";
    FiatCurrency["FJD"] = "FJD";
    FiatCurrency["FKP"] = "FKP";
    FiatCurrency["GBP"] = "GBP";
    FiatCurrency["GEL"] = "GEL";
    FiatCurrency["GHS"] = "GHS";
    FiatCurrency["GIP"] = "GIP";
    FiatCurrency["GMD"] = "GMD";
    FiatCurrency["GNF"] = "GNF";
    FiatCurrency["GTQ"] = "GTQ";
    FiatCurrency["GYD"] = "GYD";
    FiatCurrency["HKD"] = "HKD";
    FiatCurrency["HNL"] = "HNL";
    FiatCurrency["HRK"] = "HRK";
    FiatCurrency["HTG"] = "HTG";
    FiatCurrency["HUF"] = "HUF";
    FiatCurrency["IDR"] = "IDR";
    FiatCurrency["ILS"] = "ILS";
    FiatCurrency["INR"] = "INR";
    FiatCurrency["IQD"] = "IQD";
    FiatCurrency["IRR"] = "IRR";
    FiatCurrency["ISK"] = "ISK";
    FiatCurrency["JMD"] = "JMD";
    FiatCurrency["JOD"] = "JOD";
    FiatCurrency["JPY"] = "JPY";
    FiatCurrency["KES"] = "KES";
    FiatCurrency["KGS"] = "KGS";
    FiatCurrency["KHR"] = "KHR";
    FiatCurrency["KMF"] = "KMF";
    FiatCurrency["KPW"] = "KPW";
    FiatCurrency["KRW"] = "KRW";
    FiatCurrency["KWD"] = "KWD";
    FiatCurrency["KYD"] = "KYD";
    FiatCurrency["KZT"] = "KZT";
    FiatCurrency["LAK"] = "LAK";
    FiatCurrency["LBP"] = "LBP";
    FiatCurrency["LKR"] = "LKR";
    FiatCurrency["LRD"] = "LRD";
    FiatCurrency["LSL"] = "LSL";
    FiatCurrency["LTL"] = "LTL";
    FiatCurrency["LYD"] = "LYD";
    FiatCurrency["MAD"] = "MAD";
    FiatCurrency["MDL"] = "MDL";
    FiatCurrency["MGA"] = "MGA";
    FiatCurrency["MKD"] = "MKD";
    FiatCurrency["MMK"] = "MMK";
    FiatCurrency["MNT"] = "MNT";
    FiatCurrency["MOP"] = "MOP";
    FiatCurrency["MRO"] = "MRO";
    FiatCurrency["MRU"] = "MRU";
    FiatCurrency["MUR"] = "MUR";
    FiatCurrency["MVR"] = "MVR";
    FiatCurrency["MWK"] = "MWK";
    FiatCurrency["MXN"] = "MXN";
    FiatCurrency["MXV"] = "MXV";
    FiatCurrency["MYR"] = "MYR";
    FiatCurrency["MZN"] = "MZN";
    FiatCurrency["NAD"] = "NAD";
    FiatCurrency["NGN"] = "NGN";
    FiatCurrency["NIO"] = "NIO";
    FiatCurrency["NOK"] = "NOK";
    FiatCurrency["NPR"] = "NPR";
    FiatCurrency["NZD"] = "NZD";
    FiatCurrency["OMR"] = "OMR";
    FiatCurrency["PAB"] = "PAB";
    FiatCurrency["PEN"] = "PEN";
    FiatCurrency["PGK"] = "PGK";
    FiatCurrency["PHP"] = "PHP";
    FiatCurrency["PKR"] = "PKR";
    FiatCurrency["PLN"] = "PLN";
    FiatCurrency["PYG"] = "PYG";
    FiatCurrency["QAR"] = "QAR";
    FiatCurrency["RON"] = "RON";
    FiatCurrency["RSD"] = "RSD";
    FiatCurrency["RUB"] = "RUB";
    FiatCurrency["RWF"] = "RWF";
    FiatCurrency["SAR"] = "SAR";
    FiatCurrency["SBD"] = "SBD";
    FiatCurrency["SCR"] = "SCR";
    FiatCurrency["SDG"] = "SDG";
    FiatCurrency["SEK"] = "SEK";
    FiatCurrency["SGD"] = "SGD";
    FiatCurrency["SHP"] = "SHP";
    FiatCurrency["SLL"] = "SLL";
    FiatCurrency["SOS"] = "SOS";
    FiatCurrency["SRD"] = "SRD";
    FiatCurrency["SSP"] = "SSP";
    FiatCurrency["STD"] = "STD";
    FiatCurrency["STN"] = "STN";
    FiatCurrency["SYP"] = "SYP";
    FiatCurrency["SZL"] = "SZL";
    FiatCurrency["THB"] = "THB";
    FiatCurrency["TJS"] = "TJS";
    FiatCurrency["TMT"] = "TMT";
    FiatCurrency["TND"] = "TND";
    FiatCurrency["TOP"] = "TOP";
    FiatCurrency["TRY"] = "TRY";
    FiatCurrency["TTD"] = "TTD";
    FiatCurrency["TWD"] = "TWD";
    FiatCurrency["TZS"] = "TZS";
    FiatCurrency["UAH"] = "UAH";
    FiatCurrency["UGX"] = "UGX";
    FiatCurrency["USD"] = "USD";
    FiatCurrency["USN"] = "USN";
    FiatCurrency["USS"] = "USS";
    FiatCurrency["UYI"] = "UYI";
    FiatCurrency["UYU"] = "UYU";
    FiatCurrency["UZS"] = "UZS";
    FiatCurrency["VED"] = "VED";
    FiatCurrency["VEF"] = "VEF";
    FiatCurrency["VES"] = "VES";
    FiatCurrency["VND"] = "VND";
    FiatCurrency["VUV"] = "VUV";
    FiatCurrency["WST"] = "WST";
    FiatCurrency["XAF"] = "XAF";
    FiatCurrency["XCD"] = "XCD";
    FiatCurrency["XOF"] = "XOF";
    FiatCurrency["XPF"] = "XPF";
    FiatCurrency["YER"] = "YER";
    FiatCurrency["ZAR"] = "ZAR";
    FiatCurrency["ZMK"] = "ZMK";
    FiatCurrency["ZMW"] = "ZMW";
})(exports.FiatCurrency || (exports.FiatCurrency = {}));
/** Autogenerated - CryptoCurrency */ exports.CryptoCurrency = void 0;
(function(CryptoCurrency) {
    CryptoCurrency["ALGO"] = "ALGO";
    CryptoCurrency["APT"] = "APT";
    CryptoCurrency["APTOS"] = "APTOS";
    CryptoCurrency["ARB"] = "ARB";
    CryptoCurrency["ATOM"] = "ATOM";
    CryptoCurrency["AVAX"] = "AVAX";
    CryptoCurrency["AZMX"] = "AZMX";
    CryptoCurrency["BAT"] = "BAT";
    CryptoCurrency["BCH"] = "BCH";
    CryptoCurrency["BNB"] = "BNB";
    CryptoCurrency["BNT"] = "BNT";
    CryptoCurrency["BSV"] = "BSV";
    CryptoCurrency["BTC"] = "BTC";
    CryptoCurrency["BUSD"] = "BUSD";
    CryptoCurrency["CELO"] = "CELO";
    CryptoCurrency["CORE"] = "CORE";
    CryptoCurrency["CUSDC"] = "CUSDC";
    CryptoCurrency["CVC"] = "CVC";
    CryptoCurrency["DAI"] = "DAI";
    CryptoCurrency["DOT"] = "DOT";
    CryptoCurrency["EOS"] = "EOS";
    CryptoCurrency["ETC"] = "ETC";
    CryptoCurrency["ETH"] = "ETH";
    CryptoCurrency["FIUSDC"] = "FIUSDC";
    CryptoCurrency["FLOW"] = "FLOW";
    CryptoCurrency["FOAM"] = "FOAM";
    CryptoCurrency["GNO"] = "GNO";
    CryptoCurrency["HBAR"] = "HBAR";
    CryptoCurrency["HYPEREVM"] = "HYPEREVM";
    CryptoCurrency["KNC"] = "KNC";
    CryptoCurrency["LBR"] = "LBR";
    CryptoCurrency["LOOM"] = "LOOM";
    CryptoCurrency["LPT"] = "LPT";
    CryptoCurrency["LTC"] = "LTC";
    CryptoCurrency["MANA"] = "MANA";
    CryptoCurrency["MATIC"] = "MATIC";
    CryptoCurrency["MON"] = "MON";
    CryptoCurrency["MXPT"] = "MXPT";
    CryptoCurrency["NEAR"] = "NEAR";
    CryptoCurrency["NMR"] = "NMR";
    CryptoCurrency["OMG"] = "OMG";
    CryptoCurrency["OP"] = "OP";
    CryptoCurrency["PLUME"] = "PLUME";
    CryptoCurrency["POLY"] = "POLY";
    CryptoCurrency["QTUM"] = "QTUM";
    CryptoCurrency["REP"] = "REP";
    CryptoCurrency["SEI"] = "SEI";
    CryptoCurrency["SNT"] = "SNT";
    CryptoCurrency["SOL"] = "SOL";
    CryptoCurrency["SONIC"] = "SONIC";
    CryptoCurrency["STORJ"] = "STORJ";
    CryptoCurrency["STRK"] = "STRK";
    CryptoCurrency["SUI"] = "SUI";
    CryptoCurrency["TON"] = "TON";
    CryptoCurrency["TRX"] = "TRX";
    CryptoCurrency["USDCb"] = "USDCb";
    CryptoCurrency["USDCe"] = "USDCe";
    CryptoCurrency["USDT"] = "USDT";
    CryptoCurrency["USYC"] = "USYC";
    CryptoCurrency["WBTC"] = "WBTC";
    CryptoCurrency["WETH"] = "WETH";
    CryptoCurrency["XDC"] = "XDC";
    CryptoCurrency["XLM"] = "XLM";
    CryptoCurrency["XMR"] = "XMR";
    CryptoCurrency["XRP"] = "XRP";
    CryptoCurrency["ZEC"] = "ZEC";
    CryptoCurrency["ZRX"] = "ZRX";
})(exports.CryptoCurrency || (exports.CryptoCurrency = {}));
/** Autogenerated - StablecoinCurrency */ exports.StablecoinCurrency = void 0;
(function(StablecoinCurrency) {
    StablecoinCurrency["EURC"] = "EURC";
    StablecoinCurrency["USDC"] = "USDC";
})(exports.StablecoinCurrency || (exports.StablecoinCurrency = {}));
/** Autogenerated - Currency */ exports.Currency = void 0;
(function(Currency) {
    // Fiat
    Currency["AED"] = "AED";
    Currency["AFN"] = "AFN";
    Currency["ALL"] = "ALL";
    Currency["AMD"] = "AMD";
    Currency["ANG"] = "ANG";
    Currency["AOA"] = "AOA";
    Currency["ARS"] = "ARS";
    Currency["AUD"] = "AUD";
    Currency["AWG"] = "AWG";
    Currency["AZN"] = "AZN";
    Currency["BAM"] = "BAM";
    Currency["BBD"] = "BBD";
    Currency["BDT"] = "BDT";
    Currency["BGN"] = "BGN";
    Currency["BHD"] = "BHD";
    Currency["BIF"] = "BIF";
    Currency["BMD"] = "BMD";
    Currency["BND"] = "BND";
    Currency["BOB"] = "BOB";
    Currency["BOV"] = "BOV";
    Currency["BRL"] = "BRL";
    Currency["BSD"] = "BSD";
    Currency["BTN"] = "BTN";
    Currency["BWP"] = "BWP";
    Currency["BYN"] = "BYN";
    Currency["BYR"] = "BYR";
    Currency["BZD"] = "BZD";
    Currency["CAD"] = "CAD";
    Currency["CDF"] = "CDF";
    Currency["CHE"] = "CHE";
    Currency["CHF"] = "CHF";
    Currency["CHW"] = "CHW";
    Currency["CLF"] = "CLF";
    Currency["CLP"] = "CLP";
    Currency["CNH"] = "CNH";
    Currency["CNY"] = "CNY";
    Currency["COP"] = "COP";
    Currency["COU"] = "COU";
    Currency["CRC"] = "CRC";
    Currency["CUC"] = "CUC";
    Currency["CUP"] = "CUP";
    Currency["CVE"] = "CVE";
    Currency["CZK"] = "CZK";
    Currency["DJF"] = "DJF";
    Currency["DKK"] = "DKK";
    Currency["DOP"] = "DOP";
    Currency["DZD"] = "DZD";
    Currency["EGP"] = "EGP";
    Currency["ERN"] = "ERN";
    Currency["ETB"] = "ETB";
    Currency["EUR"] = "EUR";
    Currency["FIUSD"] = "FIUSD";
    Currency["FJD"] = "FJD";
    Currency["FKP"] = "FKP";
    Currency["GBP"] = "GBP";
    Currency["GEL"] = "GEL";
    Currency["GHS"] = "GHS";
    Currency["GIP"] = "GIP";
    Currency["GMD"] = "GMD";
    Currency["GNF"] = "GNF";
    Currency["GTQ"] = "GTQ";
    Currency["GYD"] = "GYD";
    Currency["HKD"] = "HKD";
    Currency["HNL"] = "HNL";
    Currency["HRK"] = "HRK";
    Currency["HTG"] = "HTG";
    Currency["HUF"] = "HUF";
    Currency["IDR"] = "IDR";
    Currency["ILS"] = "ILS";
    Currency["INR"] = "INR";
    Currency["IQD"] = "IQD";
    Currency["IRR"] = "IRR";
    Currency["ISK"] = "ISK";
    Currency["JMD"] = "JMD";
    Currency["JOD"] = "JOD";
    Currency["JPY"] = "JPY";
    Currency["KES"] = "KES";
    Currency["KGS"] = "KGS";
    Currency["KHR"] = "KHR";
    Currency["KMF"] = "KMF";
    Currency["KPW"] = "KPW";
    Currency["KRW"] = "KRW";
    Currency["KWD"] = "KWD";
    Currency["KYD"] = "KYD";
    Currency["KZT"] = "KZT";
    Currency["LAK"] = "LAK";
    Currency["LBP"] = "LBP";
    Currency["LKR"] = "LKR";
    Currency["LRD"] = "LRD";
    Currency["LSL"] = "LSL";
    Currency["LTL"] = "LTL";
    Currency["LYD"] = "LYD";
    Currency["MAD"] = "MAD";
    Currency["MDL"] = "MDL";
    Currency["MGA"] = "MGA";
    Currency["MKD"] = "MKD";
    Currency["MMK"] = "MMK";
    Currency["MNT"] = "MNT";
    Currency["MOP"] = "MOP";
    Currency["MRO"] = "MRO";
    Currency["MRU"] = "MRU";
    Currency["MUR"] = "MUR";
    Currency["MVR"] = "MVR";
    Currency["MWK"] = "MWK";
    Currency["MXN"] = "MXN";
    Currency["MXV"] = "MXV";
    Currency["MYR"] = "MYR";
    Currency["MZN"] = "MZN";
    Currency["NAD"] = "NAD";
    Currency["NGN"] = "NGN";
    Currency["NIO"] = "NIO";
    Currency["NOK"] = "NOK";
    Currency["NPR"] = "NPR";
    Currency["NZD"] = "NZD";
    Currency["OMR"] = "OMR";
    Currency["PAB"] = "PAB";
    Currency["PEN"] = "PEN";
    Currency["PGK"] = "PGK";
    Currency["PHP"] = "PHP";
    Currency["PKR"] = "PKR";
    Currency["PLN"] = "PLN";
    Currency["PYG"] = "PYG";
    Currency["QAR"] = "QAR";
    Currency["RON"] = "RON";
    Currency["RSD"] = "RSD";
    Currency["RUB"] = "RUB";
    Currency["RWF"] = "RWF";
    Currency["SAR"] = "SAR";
    Currency["SBD"] = "SBD";
    Currency["SCR"] = "SCR";
    Currency["SDG"] = "SDG";
    Currency["SEK"] = "SEK";
    Currency["SGD"] = "SGD";
    Currency["SHP"] = "SHP";
    Currency["SLL"] = "SLL";
    Currency["SOS"] = "SOS";
    Currency["SRD"] = "SRD";
    Currency["SSP"] = "SSP";
    Currency["STD"] = "STD";
    Currency["STN"] = "STN";
    Currency["SYP"] = "SYP";
    Currency["SZL"] = "SZL";
    Currency["THB"] = "THB";
    Currency["TJS"] = "TJS";
    Currency["TMT"] = "TMT";
    Currency["TND"] = "TND";
    Currency["TOP"] = "TOP";
    Currency["TRY"] = "TRY";
    Currency["TTD"] = "TTD";
    Currency["TWD"] = "TWD";
    Currency["TZS"] = "TZS";
    Currency["UAH"] = "UAH";
    Currency["UGX"] = "UGX";
    Currency["USD"] = "USD";
    Currency["USN"] = "USN";
    Currency["USS"] = "USS";
    Currency["UYI"] = "UYI";
    Currency["UYU"] = "UYU";
    Currency["UZS"] = "UZS";
    Currency["VED"] = "VED";
    Currency["VEF"] = "VEF";
    Currency["VES"] = "VES";
    Currency["VND"] = "VND";
    Currency["VUV"] = "VUV";
    Currency["WST"] = "WST";
    Currency["XAF"] = "XAF";
    Currency["XCD"] = "XCD";
    Currency["XOF"] = "XOF";
    Currency["XPF"] = "XPF";
    Currency["YER"] = "YER";
    Currency["ZAR"] = "ZAR";
    Currency["ZMK"] = "ZMK";
    Currency["ZMW"] = "ZMW";
    // Crypto
    Currency["ALGO"] = "ALGO";
    Currency["APT"] = "APT";
    Currency["APTOS"] = "APTOS";
    Currency["ARB"] = "ARB";
    Currency["ATOM"] = "ATOM";
    Currency["AVAX"] = "AVAX";
    Currency["AZMX"] = "AZMX";
    Currency["BAT"] = "BAT";
    Currency["BCH"] = "BCH";
    Currency["BNB"] = "BNB";
    Currency["BNT"] = "BNT";
    Currency["BSV"] = "BSV";
    Currency["BTC"] = "BTC";
    Currency["BUSD"] = "BUSD";
    Currency["CELO"] = "CELO";
    Currency["CORE"] = "CORE";
    Currency["CUSDC"] = "CUSDC";
    Currency["CVC"] = "CVC";
    Currency["DAI"] = "DAI";
    Currency["DOT"] = "DOT";
    Currency["EOS"] = "EOS";
    Currency["ETC"] = "ETC";
    Currency["ETH"] = "ETH";
    Currency["FIUSDC"] = "FIUSDC";
    Currency["FLOW"] = "FLOW";
    Currency["FOAM"] = "FOAM";
    Currency["GNO"] = "GNO";
    Currency["HBAR"] = "HBAR";
    Currency["HYPEREVM"] = "HYPEREVM";
    Currency["KNC"] = "KNC";
    Currency["LBR"] = "LBR";
    Currency["LOOM"] = "LOOM";
    Currency["LPT"] = "LPT";
    Currency["LTC"] = "LTC";
    Currency["MANA"] = "MANA";
    Currency["MATIC"] = "MATIC";
    Currency["MON"] = "MON";
    Currency["MXPT"] = "MXPT";
    Currency["NEAR"] = "NEAR";
    Currency["NMR"] = "NMR";
    Currency["OMG"] = "OMG";
    Currency["OP"] = "OP";
    Currency["PLUME"] = "PLUME";
    Currency["POLY"] = "POLY";
    Currency["QTUM"] = "QTUM";
    Currency["REP"] = "REP";
    Currency["SEI"] = "SEI";
    Currency["SNT"] = "SNT";
    Currency["SOL"] = "SOL";
    Currency["SONIC"] = "SONIC";
    Currency["STORJ"] = "STORJ";
    Currency["STRK"] = "STRK";
    Currency["SUI"] = "SUI";
    Currency["TON"] = "TON";
    Currency["TRX"] = "TRX";
    Currency["USDCb"] = "USDCb";
    Currency["USDCe"] = "USDCe";
    Currency["USDT"] = "USDT";
    Currency["USYC"] = "USYC";
    Currency["WBTC"] = "WBTC";
    Currency["WETH"] = "WETH";
    Currency["XDC"] = "XDC";
    Currency["XLM"] = "XLM";
    Currency["XMR"] = "XMR";
    Currency["XRP"] = "XRP";
    Currency["ZEC"] = "ZEC";
    Currency["ZRX"] = "ZRX";
    // Stable
    Currency["EURC"] = "EURC";
    Currency["USDC"] = "USDC";
})(exports.Currency || (exports.Currency = {}));
/** Runtime type guard for FiatCurrency */ function isFiatCurrency(currency) {
    return typeof currency === 'string' && Object.values(exports.FiatCurrency).includes(currency);
}
/** Runtime type guard for CryptoCurrency */ function isCryptoCurrency(currency) {
    return typeof currency === 'string' && Object.values(exports.CryptoCurrency).includes(currency);
}
/** Runtime type guard for StablecoinCurrency */ function isStablecoinCurrency(currency) {
    return typeof currency === 'string' && Object.values(exports.StablecoinCurrency).includes(currency);
}
/** Runtime type guard for Currency */ function isCurrency(currency) {
    return typeof currency === 'string' && Object.values(exports.Currency).includes(currency);
}

// AUTO-GENERATED — DO NOT EDIT
/** Runtime metadata for each currency code */ const currencyVariants = {
    AED: {
        name: 'AED',
        decimals: 2,
        isCryptoCurrency: false
    },
    AFN: {
        name: 'AFN',
        decimals: 2,
        isCryptoCurrency: false
    },
    ALL: {
        name: 'ALL',
        decimals: 2,
        isCryptoCurrency: false
    },
    AMD: {
        name: 'AMD',
        decimals: 2,
        isCryptoCurrency: false
    },
    ANG: {
        name: 'ANG',
        decimals: 2,
        isCryptoCurrency: false
    },
    AOA: {
        name: 'AOA',
        decimals: 2,
        isCryptoCurrency: false
    },
    ARS: {
        name: 'ARS',
        decimals: 2,
        isCryptoCurrency: false
    },
    AUD: {
        name: 'AUD',
        decimals: 2,
        isCryptoCurrency: false
    },
    AWG: {
        name: 'AWG',
        decimals: 2,
        isCryptoCurrency: false
    },
    AZN: {
        name: 'AZN',
        decimals: 2,
        isCryptoCurrency: false
    },
    BAM: {
        name: 'BAM',
        decimals: 2,
        isCryptoCurrency: false
    },
    BBD: {
        name: 'BBD',
        decimals: 2,
        isCryptoCurrency: false
    },
    BDT: {
        name: 'BDT',
        decimals: 2,
        isCryptoCurrency: false
    },
    BGN: {
        name: 'BGN',
        decimals: 2,
        isCryptoCurrency: false
    },
    BHD: {
        name: 'BHD',
        decimals: 3,
        isCryptoCurrency: false
    },
    BIF: {
        name: 'BIF',
        decimals: 0,
        isCryptoCurrency: false
    },
    BMD: {
        name: 'BMD',
        decimals: 2,
        isCryptoCurrency: false
    },
    BND: {
        name: 'BND',
        decimals: 2,
        isCryptoCurrency: false
    },
    BOB: {
        name: 'BOB',
        decimals: 2,
        isCryptoCurrency: false
    },
    BOV: {
        name: 'BOV',
        decimals: 2,
        isCryptoCurrency: false
    },
    BRL: {
        name: 'BRL',
        decimals: 2,
        isCryptoCurrency: false
    },
    BSD: {
        name: 'BSD',
        decimals: 2,
        isCryptoCurrency: false
    },
    BTN: {
        name: 'BTN',
        decimals: 2,
        isCryptoCurrency: false
    },
    BWP: {
        name: 'BWP',
        decimals: 2,
        isCryptoCurrency: false
    },
    BYN: {
        name: 'BYN',
        decimals: 2,
        isCryptoCurrency: false
    },
    BYR: {
        name: 'BYR',
        decimals: 0,
        isCryptoCurrency: false
    },
    BZD: {
        name: 'BZD',
        decimals: 2,
        isCryptoCurrency: false
    },
    CAD: {
        name: 'CAD',
        decimals: 2,
        isCryptoCurrency: false
    },
    CDF: {
        name: 'CDF',
        decimals: 2,
        isCryptoCurrency: false
    },
    CHE: {
        name: 'CHE',
        decimals: 2,
        isCryptoCurrency: false
    },
    CHF: {
        name: 'CHF',
        decimals: 2,
        isCryptoCurrency: false
    },
    CHW: {
        name: 'CHW',
        decimals: 2,
        isCryptoCurrency: false
    },
    CLF: {
        name: 'CLF',
        decimals: 4,
        isCryptoCurrency: false
    },
    CLP: {
        name: 'CLP',
        decimals: 0,
        isCryptoCurrency: false
    },
    CNH: {
        name: 'CNH',
        decimals: 2,
        isCryptoCurrency: false
    },
    CNY: {
        name: 'CNY',
        decimals: 2,
        isCryptoCurrency: false
    },
    COP: {
        name: 'COP',
        decimals: 2,
        isCryptoCurrency: false
    },
    COU: {
        name: 'COU',
        decimals: 2,
        isCryptoCurrency: false
    },
    CRC: {
        name: 'CRC',
        decimals: 2,
        isCryptoCurrency: false
    },
    CUC: {
        name: 'CUC',
        decimals: 2,
        isCryptoCurrency: false
    },
    CUP: {
        name: 'CUP',
        decimals: 2,
        isCryptoCurrency: false
    },
    CVE: {
        name: 'CVE',
        decimals: 2,
        isCryptoCurrency: false
    },
    CZK: {
        name: 'CZK',
        decimals: 2,
        isCryptoCurrency: false
    },
    DJF: {
        name: 'DJF',
        decimals: 0,
        isCryptoCurrency: false
    },
    DKK: {
        name: 'DKK',
        decimals: 2,
        isCryptoCurrency: false
    },
    DOP: {
        name: 'DOP',
        decimals: 2,
        isCryptoCurrency: false
    },
    DZD: {
        name: 'DZD',
        decimals: 2,
        isCryptoCurrency: false
    },
    EGP: {
        name: 'EGP',
        decimals: 2,
        isCryptoCurrency: false
    },
    ERN: {
        name: 'ERN',
        decimals: 2,
        isCryptoCurrency: false
    },
    ETB: {
        name: 'ETB',
        decimals: 2,
        isCryptoCurrency: false
    },
    EUR: {
        name: 'EUR',
        decimals: 2,
        isCryptoCurrency: false
    },
    FIUSD: {
        name: 'FIUSD',
        decimals: 2,
        isCryptoCurrency: false
    },
    FJD: {
        name: 'FJD',
        decimals: 2,
        isCryptoCurrency: false
    },
    FKP: {
        name: 'FKP',
        decimals: 2,
        isCryptoCurrency: false
    },
    GBP: {
        name: 'GBP',
        decimals: 2,
        isCryptoCurrency: false
    },
    GEL: {
        name: 'GEL',
        decimals: 2,
        isCryptoCurrency: false
    },
    GHS: {
        name: 'GHS',
        decimals: 2,
        isCryptoCurrency: false
    },
    GIP: {
        name: 'GIP',
        decimals: 2,
        isCryptoCurrency: false
    },
    GMD: {
        name: 'GMD',
        decimals: 2,
        isCryptoCurrency: false
    },
    GNF: {
        name: 'GNF',
        decimals: 0,
        isCryptoCurrency: false
    },
    GTQ: {
        name: 'GTQ',
        decimals: 2,
        isCryptoCurrency: false
    },
    GYD: {
        name: 'GYD',
        decimals: 2,
        isCryptoCurrency: false
    },
    HKD: {
        name: 'HKD',
        decimals: 2,
        isCryptoCurrency: false
    },
    HNL: {
        name: 'HNL',
        decimals: 2,
        isCryptoCurrency: false
    },
    HRK: {
        name: 'HRK',
        decimals: 2,
        isCryptoCurrency: false
    },
    HTG: {
        name: 'HTG',
        decimals: 2,
        isCryptoCurrency: false
    },
    HUF: {
        name: 'HUF',
        decimals: 2,
        isCryptoCurrency: false
    },
    IDR: {
        name: 'IDR',
        decimals: 2,
        isCryptoCurrency: false
    },
    ILS: {
        name: 'ILS',
        decimals: 2,
        isCryptoCurrency: false
    },
    INR: {
        name: 'INR',
        decimals: 2,
        isCryptoCurrency: false
    },
    IQD: {
        name: 'IQD',
        decimals: 3,
        isCryptoCurrency: false
    },
    IRR: {
        name: 'IRR',
        decimals: 2,
        isCryptoCurrency: false
    },
    ISK: {
        name: 'ISK',
        decimals: 0,
        isCryptoCurrency: false
    },
    JMD: {
        name: 'JMD',
        decimals: 2,
        isCryptoCurrency: false
    },
    JOD: {
        name: 'JOD',
        decimals: 3,
        isCryptoCurrency: false
    },
    JPY: {
        name: 'JPY',
        decimals: 0,
        isCryptoCurrency: false
    },
    KES: {
        name: 'KES',
        decimals: 2,
        isCryptoCurrency: false
    },
    KGS: {
        name: 'KGS',
        decimals: 2,
        isCryptoCurrency: false
    },
    KHR: {
        name: 'KHR',
        decimals: 2,
        isCryptoCurrency: false
    },
    KMF: {
        name: 'KMF',
        decimals: 0,
        isCryptoCurrency: false
    },
    KPW: {
        name: 'KPW',
        decimals: 2,
        isCryptoCurrency: false
    },
    KRW: {
        name: 'KRW',
        decimals: 0,
        isCryptoCurrency: false
    },
    KWD: {
        name: 'KWD',
        decimals: 3,
        isCryptoCurrency: false
    },
    KYD: {
        name: 'KYD',
        decimals: 2,
        isCryptoCurrency: false
    },
    KZT: {
        name: 'KZT',
        decimals: 2,
        isCryptoCurrency: false
    },
    LAK: {
        name: 'LAK',
        decimals: 2,
        isCryptoCurrency: false
    },
    LBP: {
        name: 'LBP',
        decimals: 2,
        isCryptoCurrency: false
    },
    LKR: {
        name: 'LKR',
        decimals: 2,
        isCryptoCurrency: false
    },
    LRD: {
        name: 'LRD',
        decimals: 2,
        isCryptoCurrency: false
    },
    LSL: {
        name: 'LSL',
        decimals: 2,
        isCryptoCurrency: false
    },
    LTL: {
        name: 'LTL',
        decimals: 2,
        isCryptoCurrency: false
    },
    LYD: {
        name: 'LYD',
        decimals: 3,
        isCryptoCurrency: false
    },
    MAD: {
        name: 'MAD',
        decimals: 2,
        isCryptoCurrency: false
    },
    MDL: {
        name: 'MDL',
        decimals: 2,
        isCryptoCurrency: false
    },
    MGA: {
        name: 'MGA',
        decimals: 2,
        isCryptoCurrency: false
    },
    MKD: {
        name: 'MKD',
        decimals: 2,
        isCryptoCurrency: false
    },
    MMK: {
        name: 'MMK',
        decimals: 2,
        isCryptoCurrency: false
    },
    MNT: {
        name: 'MNT',
        decimals: 2,
        isCryptoCurrency: false
    },
    MOP: {
        name: 'MOP',
        decimals: 2,
        isCryptoCurrency: false
    },
    MRO: {
        name: 'MRO',
        decimals: 2,
        isCryptoCurrency: false
    },
    MRU: {
        name: 'MRU',
        decimals: 2,
        isCryptoCurrency: false
    },
    MUR: {
        name: 'MUR',
        decimals: 2,
        isCryptoCurrency: false
    },
    MVR: {
        name: 'MVR',
        decimals: 2,
        isCryptoCurrency: false
    },
    MWK: {
        name: 'MWK',
        decimals: 2,
        isCryptoCurrency: false
    },
    MXN: {
        name: 'MXN',
        decimals: 2,
        isCryptoCurrency: false
    },
    MXV: {
        name: 'MXV',
        decimals: 2,
        isCryptoCurrency: false
    },
    MYR: {
        name: 'MYR',
        decimals: 2,
        isCryptoCurrency: false
    },
    MZN: {
        name: 'MZN',
        decimals: 2,
        isCryptoCurrency: false
    },
    NAD: {
        name: 'NAD',
        decimals: 2,
        isCryptoCurrency: false
    },
    NGN: {
        name: 'NGN',
        decimals: 2,
        isCryptoCurrency: false
    },
    NIO: {
        name: 'NIO',
        decimals: 2,
        isCryptoCurrency: false
    },
    NOK: {
        name: 'NOK',
        decimals: 2,
        isCryptoCurrency: false
    },
    NPR: {
        name: 'NPR',
        decimals: 2,
        isCryptoCurrency: false
    },
    NZD: {
        name: 'NZD',
        decimals: 2,
        isCryptoCurrency: false
    },
    OMR: {
        name: 'OMR',
        decimals: 3,
        isCryptoCurrency: false
    },
    PAB: {
        name: 'PAB',
        decimals: 2,
        isCryptoCurrency: false
    },
    PEN: {
        name: 'PEN',
        decimals: 2,
        isCryptoCurrency: false
    },
    PGK: {
        name: 'PGK',
        decimals: 2,
        isCryptoCurrency: false
    },
    PHP: {
        name: 'PHP',
        decimals: 2,
        isCryptoCurrency: false
    },
    PKR: {
        name: 'PKR',
        decimals: 2,
        isCryptoCurrency: false
    },
    PLN: {
        name: 'PLN',
        decimals: 2,
        isCryptoCurrency: false
    },
    PYG: {
        name: 'PYG',
        decimals: 0,
        isCryptoCurrency: false
    },
    QAR: {
        name: 'QAR',
        decimals: 2,
        isCryptoCurrency: false
    },
    RON: {
        name: 'RON',
        decimals: 2,
        isCryptoCurrency: false
    },
    RSD: {
        name: 'RSD',
        decimals: 2,
        isCryptoCurrency: false
    },
    RUB: {
        name: 'RUB',
        decimals: 2,
        isCryptoCurrency: false
    },
    RWF: {
        name: 'RWF',
        decimals: 0,
        isCryptoCurrency: false
    },
    SAR: {
        name: 'SAR',
        decimals: 2,
        isCryptoCurrency: false
    },
    SBD: {
        name: 'SBD',
        decimals: 2,
        isCryptoCurrency: false
    },
    SCR: {
        name: 'SCR',
        decimals: 2,
        isCryptoCurrency: false
    },
    SDG: {
        name: 'SDG',
        decimals: 2,
        isCryptoCurrency: false
    },
    SEK: {
        name: 'SEK',
        decimals: 2,
        isCryptoCurrency: false
    },
    SGD: {
        name: 'SGD',
        decimals: 2,
        isCryptoCurrency: false
    },
    SHP: {
        name: 'SHP',
        decimals: 2,
        isCryptoCurrency: false
    },
    SLL: {
        name: 'SLL',
        decimals: 2,
        isCryptoCurrency: false
    },
    SOS: {
        name: 'SOS',
        decimals: 2,
        isCryptoCurrency: false
    },
    SRD: {
        name: 'SRD',
        decimals: 2,
        isCryptoCurrency: false
    },
    SSP: {
        name: 'SSP',
        decimals: 2,
        isCryptoCurrency: false
    },
    STD: {
        name: 'STD',
        decimals: 2,
        isCryptoCurrency: false
    },
    STN: {
        name: 'STN',
        decimals: 2,
        isCryptoCurrency: false
    },
    SYP: {
        name: 'SYP',
        decimals: 2,
        isCryptoCurrency: false
    },
    SZL: {
        name: 'SZL',
        decimals: 2,
        isCryptoCurrency: false
    },
    THB: {
        name: 'THB',
        decimals: 2,
        isCryptoCurrency: false
    },
    TJS: {
        name: 'TJS',
        decimals: 2,
        isCryptoCurrency: false
    },
    TMT: {
        name: 'TMT',
        decimals: 2,
        isCryptoCurrency: false
    },
    TND: {
        name: 'TND',
        decimals: 3,
        isCryptoCurrency: false
    },
    TOP: {
        name: 'TOP',
        decimals: 2,
        isCryptoCurrency: false
    },
    TRY: {
        name: 'TRY',
        decimals: 2,
        isCryptoCurrency: false
    },
    TTD: {
        name: 'TTD',
        decimals: 2,
        isCryptoCurrency: false
    },
    TWD: {
        name: 'TWD',
        decimals: 2,
        isCryptoCurrency: false
    },
    TZS: {
        name: 'TZS',
        decimals: 2,
        isCryptoCurrency: false
    },
    UAH: {
        name: 'UAH',
        decimals: 2,
        isCryptoCurrency: false
    },
    UGX: {
        name: 'UGX',
        decimals: 0,
        isCryptoCurrency: false
    },
    USD: {
        name: 'USD',
        decimals: 2,
        isCryptoCurrency: false
    },
    USN: {
        name: 'USN',
        decimals: 2,
        isCryptoCurrency: false
    },
    USS: {
        name: 'USS',
        decimals: 2,
        isCryptoCurrency: false
    },
    UYI: {
        name: 'UYI',
        decimals: 0,
        isCryptoCurrency: false
    },
    UYU: {
        name: 'UYU',
        decimals: 2,
        isCryptoCurrency: false
    },
    UZS: {
        name: 'UZS',
        decimals: 2,
        isCryptoCurrency: false
    },
    VED: {
        name: 'VED',
        decimals: 2,
        isCryptoCurrency: false
    },
    VEF: {
        name: 'VEF',
        decimals: 2,
        isCryptoCurrency: false
    },
    VES: {
        name: 'VES',
        decimals: 2,
        isCryptoCurrency: false
    },
    VND: {
        name: 'VND',
        decimals: 0,
        isCryptoCurrency: false
    },
    VUV: {
        name: 'VUV',
        decimals: 0,
        isCryptoCurrency: false
    },
    WST: {
        name: 'WST',
        decimals: 2,
        isCryptoCurrency: false
    },
    XAF: {
        name: 'XAF',
        decimals: 0,
        isCryptoCurrency: false
    },
    XCD: {
        name: 'XCD',
        decimals: 2,
        isCryptoCurrency: false
    },
    XOF: {
        name: 'XOF',
        decimals: 0,
        isCryptoCurrency: false
    },
    XPF: {
        name: 'XPF',
        decimals: 0,
        isCryptoCurrency: false
    },
    YER: {
        name: 'YER',
        decimals: 2,
        isCryptoCurrency: false
    },
    ZAR: {
        name: 'ZAR',
        decimals: 2,
        isCryptoCurrency: false
    },
    ZMK: {
        name: 'ZMK',
        decimals: 2,
        isCryptoCurrency: false
    },
    ZMW: {
        name: 'ZMW',
        decimals: 2,
        isCryptoCurrency: false
    },
    ALGO: {
        name: 'ALGO',
        decimals: 6,
        isCryptoCurrency: true
    },
    APT: {
        name: 'APT',
        decimals: 8,
        isCryptoCurrency: true
    },
    APTOS: {
        name: 'APTOS',
        decimals: 9,
        isCryptoCurrency: true
    },
    ARB: {
        name: 'ARB',
        decimals: 18,
        isCryptoCurrency: true
    },
    ATOM: {
        name: 'ATOM',
        decimals: 6,
        isCryptoCurrency: true
    },
    AVAX: {
        name: 'AVAX',
        decimals: 18,
        isCryptoCurrency: true
    },
    AZMX: {
        name: 'AZMX',
        decimals: 6,
        isCryptoCurrency: true
    },
    BAT: {
        name: 'BAT',
        decimals: 18,
        isCryptoCurrency: true
    },
    BCH: {
        name: 'BCH',
        decimals: 8,
        isCryptoCurrency: true
    },
    BNB: {
        name: 'BNB',
        decimals: 18,
        isCryptoCurrency: true
    },
    BNT: {
        name: 'BNT',
        decimals: 18,
        isCryptoCurrency: true
    },
    BSV: {
        name: 'BSV',
        decimals: 8,
        isCryptoCurrency: true
    },
    BTC: {
        name: 'BTC',
        symbol: '₿',
        decimals: 8,
        isCryptoCurrency: true
    },
    BUSD: {
        name: 'BUSD',
        decimals: 18,
        isCryptoCurrency: true
    },
    CELO: {
        name: 'CELO',
        decimals: 18,
        isCryptoCurrency: true
    },
    CORE: {
        name: 'CORE',
        decimals: 18,
        isCryptoCurrency: true
    },
    CUSDC: {
        name: 'CUSDC',
        decimals: 8,
        isCryptoCurrency: true
    },
    CVC: {
        name: 'CVC',
        decimals: 8,
        isCryptoCurrency: true
    },
    DAI: {
        name: 'DAI',
        decimals: 18,
        isCryptoCurrency: true
    },
    DOT: {
        name: 'DOT',
        decimals: 10,
        isCryptoCurrency: true
    },
    EOS: {
        name: 'EOS',
        decimals: 4,
        isCryptoCurrency: true
    },
    ETC: {
        name: 'ETC',
        decimals: 18,
        isCryptoCurrency: true
    },
    ETH: {
        name: 'ETH',
        symbol: 'Ξ',
        decimals: 18,
        isCryptoCurrency: true
    },
    FIUSDC: {
        name: 'FIUSDC',
        decimals: 6,
        isCryptoCurrency: true
    },
    FLOW: {
        name: 'FLOW',
        decimals: 8,
        isCryptoCurrency: true
    },
    FOAM: {
        name: 'FOAM',
        decimals: 18,
        isCryptoCurrency: true
    },
    GNO: {
        name: 'GNO',
        decimals: 18,
        isCryptoCurrency: true
    },
    HBAR: {
        name: 'HBAR',
        decimals: 8,
        isCryptoCurrency: true
    },
    HYPEREVM: {
        name: 'HYPEREVM',
        decimals: 18,
        isCryptoCurrency: true
    },
    KNC: {
        name: 'KNC',
        decimals: 18,
        isCryptoCurrency: true
    },
    LBR: {
        name: 'LBR',
        decimals: 18,
        isCryptoCurrency: true
    },
    LOOM: {
        name: 'LOOM',
        decimals: 18,
        isCryptoCurrency: true
    },
    LPT: {
        name: 'LPT',
        decimals: 18,
        isCryptoCurrency: true
    },
    LTC: {
        name: 'LTC',
        decimals: 8,
        isCryptoCurrency: true
    },
    MANA: {
        name: 'MANA',
        decimals: 18,
        isCryptoCurrency: true
    },
    MATIC: {
        name: 'MATIC',
        decimals: 18,
        isCryptoCurrency: true
    },
    MON: {
        name: 'MON',
        decimals: 18,
        isCryptoCurrency: true
    },
    MXPT: {
        name: 'MXPT',
        decimals: 6,
        isCryptoCurrency: true
    },
    NEAR: {
        name: 'NEAR',
        decimals: 24,
        isCryptoCurrency: true
    },
    NMR: {
        name: 'NMR',
        decimals: 18,
        isCryptoCurrency: true
    },
    OMG: {
        name: 'OMG',
        decimals: 18,
        isCryptoCurrency: true
    },
    OP: {
        name: 'OP',
        decimals: 18,
        isCryptoCurrency: true
    },
    PLUME: {
        name: 'PLUME',
        decimals: 18,
        isCryptoCurrency: true
    },
    POLY: {
        name: 'POLY',
        decimals: 18,
        isCryptoCurrency: true
    },
    QTUM: {
        name: 'QTUM',
        decimals: 8,
        isCryptoCurrency: true
    },
    REP: {
        name: 'REP',
        decimals: 18,
        isCryptoCurrency: true
    },
    SEI: {
        name: 'SEI',
        decimals: 18,
        isCryptoCurrency: true
    },
    SNT: {
        name: 'SNT',
        decimals: 18,
        isCryptoCurrency: true
    },
    SOL: {
        name: 'SOL',
        decimals: 9,
        isCryptoCurrency: true
    },
    SONIC: {
        name: 'SONIC',
        decimals: 18,
        isCryptoCurrency: true
    },
    STORJ: {
        name: 'STORJ',
        decimals: 8,
        isCryptoCurrency: true
    },
    STRK: {
        name: 'STRK',
        decimals: 18,
        isCryptoCurrency: true
    },
    SUI: {
        name: 'SUI',
        decimals: 9,
        isCryptoCurrency: true
    },
    TON: {
        name: 'TON',
        decimals: 9,
        isCryptoCurrency: true
    },
    TRX: {
        name: 'TRX',
        decimals: 6,
        isCryptoCurrency: true
    },
    USDCb: {
        name: 'USDCb',
        decimals: 6,
        isCryptoCurrency: true
    },
    USDCe: {
        name: 'USDCe',
        decimals: 6,
        isCryptoCurrency: true
    },
    USDT: {
        name: 'USDT',
        decimals: 6,
        isCryptoCurrency: true
    },
    USYC: {
        name: 'USYC',
        decimals: 6,
        isCryptoCurrency: true
    },
    WBTC: {
        name: 'WBTC',
        decimals: 8,
        isCryptoCurrency: true
    },
    WETH: {
        name: 'WETH',
        decimals: 18,
        isCryptoCurrency: true
    },
    XDC: {
        name: 'XDC',
        decimals: 18,
        isCryptoCurrency: true
    },
    XLM: {
        name: 'XLM',
        decimals: 7,
        isCryptoCurrency: true
    },
    XMR: {
        name: 'XMR',
        decimals: 12,
        isCryptoCurrency: true
    },
    XRP: {
        name: 'XRP',
        decimals: 6,
        isCryptoCurrency: true
    },
    ZEC: {
        name: 'ZEC',
        decimals: 8,
        isCryptoCurrency: true
    },
    ZRX: {
        name: 'ZRX',
        decimals: 18,
        isCryptoCurrency: true
    },
    EURC: {
        name: 'EURC',
        decimals: 2,
        isCryptoCurrency: true
    },
    USDC: {
        name: 'USDC',
        decimals: 2,
        isCryptoCurrency: true
    }
};

exports.currencyVariants = currencyVariants;
exports.isCryptoCurrency = isCryptoCurrency;
exports.isCurrency = isCurrency;
exports.isFiatCurrency = isFiatCurrency;
exports.isStablecoinCurrency = isStablecoinCurrency;
